import React, {Component} from 'react';

import PropTypes from 'prop-types';

import PageLayout from 'Frontend/components/PageLayout';
import QuickInterview from 'Frontend/components/quickInterview/QuickInterview';
import {PageConfig} from 'Server/models';

import dbConnect from 'Server/utils/dbConnect';
import {populateFooterItems} from 'Server/utils/pagePopulations';

/**
 * InterviewPage class.
 *
 * @export
 * @class InterviewPage
 * @extends {Component}
 */
export default class InterviewPage extends Component {
    static propTypes = {
        router: PropTypes.object.isRequired,
        footer: PropTypes.object,
        interview: PropTypes.object
    }

    static defaultProps = {
        footer: null,
        interview: null
    }

    /**
     * Gets the layout for this page.
     *
     * @static
     * @param {Object} router        The router object from nextjs.
     * @param {Object} pageProps     All page props given from server.
     * @param {Object} PageComponent The page component to render.
     *
     * @returns {JSX} The complete page.
     * @memberof ContentPages
     */
    static getLayout(router, pageProps, PageComponent) {
        return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <PageLayout router={router} {...pageProps}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <PageComponent router={router} {...pageProps} />
            </PageLayout>
        );
    }

    /**
     * Renders the Component.
     *
     * @returns {Component} React Component.
     * @memberof InterviewPage
     */
    render() {
        const {interview} = this.props;

        return (
            <QuickInterview interviewShort={interview} />
        );
    }
}

/**
 * Gets static props needed for the actual page.
 *
 * @returns {Object} An props object or an redirect.
 */
export async function getStaticProps() {
    let footerJson = {};
    let interview = {};

    try {
        await dbConnect();

        try {
            const interviewShort = await PageConfig.findOne({type: 'InterviewShort'});

            interview = JSON.stringify(interviewShort.toObject());
        } catch (error) {
            interview = JSON.stringify({});
        }

        try {
            const footer = await PageConfig.findOne({type: 'Footer'})
                .populate('partner')
                .populate('socialMedia.icon');

            await populateFooterItems(footer.copyright);

            footerJson = JSON.stringify(footer.toObject());
        } catch (e) {
            footerJson = JSON.stringify({});
        }
    } catch (e) {
        interview = JSON.stringify({});
        footerJson = JSON.stringify({});
    }

    return {
        props: {
            footer: JSON.parse(footerJson),
            interview: JSON.parse(interview),
            menu: {active: '/'}
        },
        revalidate: 2
    };
}